import './App.css';
import Header from './Header';
import Checkout from './Checkout';
import Home from './Home';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from './Login';
import { useEffect } from 'react';
import { auth } from './firebase';
import { useStateValue } from './Context';
import Payment from './Payment';
import { loadStripe } from '@stripe/stripe-js'
import { Elements} from '@stripe/react-stripe-js'
import Orders from './Orders';
import Register from './Register';

const promise = loadStripe('pk_test_51KY5gdSDGCNaFPV79XQfXgNSmbQNpMy3Tl2ewfKuKSRvc6zgpWWmziDOq5ksrbN8aEw5qMyFiDuEbukQ5eAbdIFH00bwxfeKIt')



function App() {
 const[{user}, dispatch] =  useStateValue()


  useEffect(()=>{
   auth.onAuthStateChanged(authUser=>{
     console.log('The User is ', authUser);

     if(authUser){
        dispatch({
          type:'SET_USER',
          user:authUser
        })
     }else{
       dispatch({
         type:'SET_USER',
         user:null
       })
     }
   })
  },[])
  return (
    <Router>
    <div className="app">
      <Switch>
        <Route path='/' exact >
      <Header/>
      <Home/>
        </Route>
        <Route path='/checkout' >
          { !user ? <Login/> :
      (<><Header /><Checkout /></>)
          }
        </Route>
        <Route path='/payment' >
          {  !user ? <Login/> : 
          <>
      <Header/>
      <Elements stripe={promise} >
      <Payment/>
      </Elements>
      </>
          }
        </Route>
        <Route path='/login' >
          
      <Login/>
        </Route>
        <Route path='/register' >
      <Register/>
        </Route>
        <Route path= '/orders' >
        { !user ? <Login/> :
        <>
        <Header/>
          <Orders/>
          </>
}
        </Route>
        
      </Switch>
    </div>
    </Router>
  );
}

export default App;
